import { CognitoUserPool } from "amazon-cognito-identity-js";
import {COGNITO_USER_POOL_ID, COGNITO_APP_CLIENT_ID} from "../../config/index"

const poolData = {
  UserPoolId: COGNITO_USER_POOL_ID,
  ClientId: COGNITO_APP_CLIENT_ID,
};

export default new CognitoUserPool(poolData);
